module.exports = __webpack_public_path__ + "media/images/knockoutbet__sample@2x-86fc6984e55d572d742f209b0ec07806.png";